<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
import { firebase } from '@/store/api/firebase'
export default {
  name: 'App',

  beforeMount () {
    firebase.auth().onAuthStateChanged(user => {
      if (user) {
        this.$store.dispatch('setUser', user.uid)
        this.$store.dispatch('setDisplayName', user.displayName.split(' ')[0])
        this.$store.dispatch('setIsVerified', user.emailVerified)
        if (this.$store.state.user.isRegistering) {
          this.$store.dispatch('getRedirectResult')
        }
      } else {
        // redirect logged out users to log back in
        if (this.$store.state.user.loggedOut === true) {
          this.$router.push({ name: 'Login' })
        }
      }
    })
  }
}
</script>



// WEBPACK FOOTER //
// src/App.vue